import { useStore } from '@/store/useStore';
import {
  getAmplitudeProduct,
  getAndroidAppVersion,
  toLoginStatus,
  toNationalJurisdiction,
} from './helpers';
import { MODULES, getAmplitudeKey } from './constants';

const safeWindowLocation = () => {
  if (typeof window === 'undefined' || !window.location) {
    return { href: '', pathname: '' };
  }

  const { href, pathname } = window.location;
  try {
    const url = new URL(href);
    return { href: `${url.origin}${url.pathname}`, pathname };
  } catch {
    return { href: pathname, pathname };
  }
};

/**
 * Reads game/user/runtime/page context from the Zustand store and window.
 * Safe to call outside React (showoff helpers, initialise, etc.).
 */
export const buildCommonTrackingContext = (): Record<string, unknown> => {
  const state = useStore.getState();
  const gameContext = state.gameContext;
  const countryCode = state.userContext?.data?.accountSettings?.countryCode;
  const userId = state.userSessionContext?.userId;
  const hasActiveSession = state.userSessionContext?.hasActiveSession;
  const platform = state.runtime?.platform;
  const balance = state.gameWindowContext?.balance;
  const { href, pathname } = safeWindowLocation();

  return {
    [getAmplitudeKey('USER_ID')]: userId ?? '-',
    [getAmplitudeKey('BALANCE')]: balance ?? '-',
    [getAmplitudeKey('GAME_ID')]:
      gameContext?.gameUid ?? gameContext?.gameId ?? '-',
    [getAmplitudeKey('GAME_NAME')]: gameContext?.gameName ?? '-',
    [getAmplitudeKey('PAGE_NAME')]: MODULES.GW,
    [getAmplitudeKey('GAME_PROVIDER')]: gameContext?.provider ?? '-',
    [getAmplitudeKey('JURISDICTION')]: gameContext?.region
      ? gameContext.region.toUpperCase()
      : '-',
    [getAmplitudeKey('NATIONAL_JURISDICTION')]:
      toNationalJurisdiction(countryCode),
    [getAmplitudeKey('APP_VERSION')]: getAndroidAppVersion(),
    [getAmplitudeKey('FULL_URL')]: href,
    [getAmplitudeKey('PRODUCT')]: getAmplitudeProduct() ?? '-',
    [getAmplitudeKey('SITE_PLATFORM')]: platform ?? '-',
    [getAmplitudeKey('PAGE_PATH')]: pathname,
    [getAmplitudeKey('LOGIN_STATUS')]: toLoginStatus(hasActiveSession),
  };
};
